export default __webpack_public_path__ + "static/media/DisneyMickeyMouse1.6cb3ef83.jpg";